export const RETRIEVE_PPA_CONTRACTS_SUCCESS = "RETRIEVE_PPA_CONTRACTS_SUCCESS";
export const PPA_CONTRACT_VALUE_CHANGE = "PPA_CONTRACT_VALUE_CHANGE";
export const PPA_CONTRACT_CLICKED = "PPA_CONTRACT_CLICKED";
export const PPA_CONTRACT_RESET = "PPA_CONTRACT_RESET";